import { loading, loaded } from '../../../../layout/redux/layoutActions';
import { decode, encode } from '@googlemaps/polyline-codec';
import Map from 'eemovel-map-library/src/data/google-maps/map';
import {
  updateDataLayers,
  removePolygons,
  resetDataLayers,
  updateOptions,
} from '../redux/dataLayers.actions';
import {
  getValueZones,
  getNeighborhood,
  getZoning,
  getMeanFamilyIncome,
} from '../infra/dataLayers.infra';
import {
  generatePolygons,
  generatePolygonsParams,
  removeAllFlowPoints,
} from '../redux/dataLayers.map';
import { AppDispatch } from '../../../../reducer';
import { ICheckboxOptions } from '../../../../component';
import { buildIncomePolygonPayload } from '../Factory/polygons.factory';
import { boundBoxToPolygon } from '../../../../helpers/geometryHelper';
import { Store } from '../../../../helpers';
import { IHandleMap } from '../types/dataLayers.types';
import { AVERAGE_INCOME, FLOW_POINTS } from '../../../../shared/constants';

// TODO:
// ADICIONAR TUDO QUE FOR RELATIVO A CONTROLE DE AÇÕES AQUI DENTRO
// GRADATIVAMENTE, VAMOS IMPLEMENTAR O CLEAN CODE

export const handleMap = ({
  checked,
  city,
}: IHandleMap): ((dispatch: AppDispatch) => void) => {
  return (dispatch: AppDispatch) => {
    dispatch(loading());
    if (checked.id === 'standardMap') {
      Map.setMapView({ view: 'roadmap' });
      dispatch([
        updateDataLayers({
          name: 'satellite',
          value: false,
        }),
        loaded(),
      ]);
    }
    if (checked.id === 'satellite') {
      Map.setMapView({
        view: checked.selected === true ? 'satellite' : 'roadmap',
      });
      dispatch([
        updateDataLayers({ name: checked.id, value: !!checked }),
        updateDataLayers({
          name: 'standardMap',
          value: false,
        }),
        loaded(),
      ]);
    }
    if (checked.id === 'neighborhood' && checked.selected) {
      dispatch(createNeighborhoodMap(city));
    } else if (checked.id === 'neighborhood' && !checked.selected) {
      dispatch(removePolygons('neighborhood'));
      dispatch(loaded());
    }
    if (checked.id === 'zoning' && checked.selected) {
      dispatch(createZoningMap(city));
    } else if (checked.id === 'zoning' && !checked.selected) {
      dispatch(removePolygons('zoning'));
      dispatch(loaded());
    }
    if (checked.id === 'valueZoning' && checked.selected) {
      dispatch(createValueZoningMap());
    } else if (checked.id === 'valueZoning' && !checked.selected) {
      dispatch(removePolygons('valueZoning'));
      dispatch(loaded());
    }
    if (checked.id === 'averageIncome' && checked.selected) {
      dispatch(
        updateOptions({
          name: 'averageIncome',
          options: AVERAGE_INCOME.map((item) => ({ ...item, checked: true })),
        })
      );
    } else if (checked.id === 'averageIncome' && !checked.selected) {
      dispatch(removePolygons('averageIncome'));
      dispatch(
        updateOptions({
          name: 'averageIncome',
          options: AVERAGE_INCOME,
        })
      );
      dispatch(loaded());
    }
    if (
      checked.id === 'censusSectors' ||
      checked.id === 'demographicDensity' ||
      checked.id === 'verticalization'
    ) {
      dispatch(loaded());
    }
    if (checked.id === 'flowPoints' && !checked.selected) {
      dispatch(updateOptions({ name: 'flowPoints', options: FLOW_POINTS }));
      dispatch(loaded());
    }
    dispatch(
      updateDataLayers({
        name: checked.id,
        value: !!checked.selected,
      })
    );
  };
};

export const clearDataLayers = () => {
  return (dispatch: AppDispatch) => {
    removeAllFlowPoints();
    dispatch([
      resetDataLayers(),
      removePolygons('neighborhood'),
      removePolygons('zoning'),
      removePolygons('valueZoning'),
      removePolygons('averageIncome'),
    ]);
  };
};

export const createValueZoningMap = () => {
  return (dispatch: AppDispatch) => {
    try {
      const google = window.google;
      Promise.resolve(getValueZones())
        .then((res) => {
          res.data?.data?.map((zone) => {
            if (zone.text !== null) {
              const coordinates = decode(zone.geometry.coordinates).map(
                (el) => new google.maps.LatLng(el[1], el[0])
              );
              dispatch(
                generatePolygons({
                  coordinates,
                  color: '#E5E5E5',
                  borderColor: '#000',
                  polygonType: 'valueZoning',
                  infowindow: {
                    content: zone.name,
                    disableAutoPan: true,
                    zIndex: 4,
                  },
                })
              );
            }
          });
        })
        .finally(() => dispatch(loaded()));
    } catch (e) {
      console.warn(e);
    }
  };
};

export const createZoningMap = (cityId: number) => {
  return (dispatch: AppDispatch) => {
    const google = window.google;
    try {
      dispatch(loading());
      Promise.resolve(getZoning(cityId))
        .then((res) => {
          res.data?.data?.map((zone) => {
            const coordinates = decode(zone.Encode[0]).map(
              (el) => new google.maps.LatLng(el[0], el[1])
            );
            const color = getZoningColor(zone.Sigla);
            dispatch(
              generatePolygons({
                coordinates,
                color,
                borderColor: '#000',
                polygonType: 'zoning',
                infowindow: {
                  content: zone.Sigla,
                  disableAutoPan: true,
                  zIndex: 4,
                },
              })
            );
          });
        })
        .finally(() => dispatch(loaded()));
    } catch (e) {
      console.warn(e);
    }
  };
};

const getZoningColor = (name: string) => {
  switch (name) {
    case '(ZER-1)':
      return '#add8e6';
    case '(ZCORa)':
      return '#347b81';
    case '(ZEIS-2)':
      return '#f99b37';
    case '(ZPR)':
      return '#fef931';
    case '(ZDE-1)':
      return '#652863';
    case '(ZPDS)':
      return '#637c55';
    case '(ZEUP)':
      return '#843d3b';
    default:
      return '';
  }
};

export const createNeighborhoodMap = (cityId: number) => {
  return (dispatch: AppDispatch) => {
    try {
      dispatch(loading());
      const google = window.google;
      Promise.resolve(getNeighborhood(cityId))
        .then((res) => {
          res.data?.data?.map((neighborhood) => {
            const coordinates = decode(
              neighborhood.geometry.coordinates[0]
            ).map((el) => {
              return new google.maps.LatLng(el[1], el[0]);
            });
            dispatch(
              generatePolygons({
                coordinates,
                color: '#383939',
                borderColor: '#383939',
                polygonType: 'neighborhood',
                infowindow: {
                  content: neighborhood.Nome,
                  disableAutoPan: true,
                  zIndex: 4,
                },
              })
            );
          });
        })
        .finally(() => dispatch(loaded()));
    } catch (e) {
      console.warn(e);
    }
  };
};

export const getFamilyIncomeFromMapDrag = () => {
  Store.dispatch(updateIncomePoligons());
};

export const isAverageIncomeActive = () => {
  const { averageIncome } = Store.getState().dataLayersState.dataLayers;
  return averageIncome.options.some(({ checked }) => checked);
};

export const hasAverageIncomePolygons = () => {
  const { polygons } = Store.getState().dataLayersState;
  return !!polygons.averageIncome.length;
};

export const shoudUpdateMap = () => {
  const zoomLevel = Map?.map?.getZoom?.();
  const hasZoom = !!zoomLevel && zoomLevel >= 15;
  return isAverageIncomeActive() && hasZoom;
};

export const encondePolygon = (poligon: google.maps.Polygon) => {
  return encode(
    poligon
      ?.getPath()
      ?.getArray()
      ?.map((el) => [el.lat(), el.lng()])
  );
};

export const shouldAddPoligon = (
  poligonType: 'neighborhood' | 'valueZoning' | 'zoning' | 'averageIncome',
  poligon: google.maps.Polygon
) => {
  const { polygons } = Store.getState().dataLayersState;
  if (poligonType !== 'averageIncome') {
    return true;
  }
  const allPolygons = polygons[poligonType].map(encondePolygon);
  const polygonToCheck = encondePolygon(poligon);
  return !allPolygons.includes(polygonToCheck);
};

export const updateIncomePoligons = () => {
  const { averageIncome } = Store.getState().dataLayersState.dataLayers;
  const availablePolygonsColors = averageIncome.options
    .filter(({ checked }) => checked)
    .map(({ color }) => color);
  return (dispatch: AppDispatch) => {
    dispatch(loading());
    const bounds = Map.map
      .getBounds()
      ?.toJSON() as google.maps.LatLngBoundsLiteral;
    const { north, east, south, west } = bounds || {
      east: 0,
      north: 0,
      south: 0,
      west: 0,
    };
    if (!!north && !!east && !!south && !!west) {
      const polygon = boundBoxToPolygon({
        north,
        east,
        south,
        west,
      });
      Promise.resolve(getMeanFamilyIncome(polygon))
        .then((response) => {
          const incomePoligons = Array.isArray(response.data)
            ? response.data
            : [response.data];
          incomePoligons.forEach((incomePoligon) => {
            const polygonToPlot: generatePolygonsParams = {
              ...buildIncomePolygonPayload(incomePoligon),
              poligonStyles: {
                visible: availablePolygonsColors.includes(incomePoligon.color),
              },
            };
            dispatch(generatePolygons(polygonToPlot));
          });
        })
        .catch((error) => console.error(error))
        .finally(() => dispatch(loaded()));
    }
  };
};

export const createMeanFamilyIncomeMap = () => {
  const currentZoom = Map?.map?.getZoom?.();
  if (currentZoom && currentZoom < 15) {
    Map?.map?.setZoom(15);
  }
  setTimeout(Store.dispatch(updateIncomePoligons()), 500);
};

export const handleCheckbox = (
  selected: ICheckboxOptions,
  name: string,
  id: string
) => {
  const DEFAULT_CITY_ID = 5270;
  const state = Store.getState();
  const { elastic_city_id } = state.mapSearch.selectedCity || {
    elastic_city_id: undefined,
  };
  const { profileRules } = state.layoutState;
  const { hasAccessGeneralMarkets } = profileRules;
  const currentCityId = elastic_city_id ? elastic_city_id : DEFAULT_CITY_ID;
  const city = hasAccessGeneralMarkets ? currentCityId : DEFAULT_CITY_ID;
  const checked = {
    selected,
    name,
    id,
  };

  Store.dispatch(
    handleMap({
      checked,
      city,
    })
  );
};
